import { render, staticRenderFns } from "./Extraction.vue?vue&type=template&id=81d05a36&"
import script from "./Extraction.vue?vue&type=script&lang=js&"
export * from "./Extraction.vue?vue&type=script&lang=js&"
import style0 from "./Extraction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports